import React, { Component } from "react";
import {
  Typography,
  Button,
  Dialog,
  TextField,
  AppBar,
  Container,
  Grid,
  Box,
  IconButton,
  Avatar,
  Drawer,
  Link,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Divider,
  Menu,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import Avatar1 from "@mui/material/Avatar";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink } from "react-router-dom";
import logoImage from "../../images/qr.avif";
import logoimg from "../../images/logo.svg";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Snackbar from "../../../common/snackbar/components/snackbar";
import JnineLogo from "../logo/j_nine_infotech_logo.png";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { CircularProgress } from "@mui/material";
const clientId =
  "458148834331-032l3iffbrnn5fqggp1caqujfhn92o6t.apps.googleusercontent.com";
class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      openLogin: false,
      openProfile: false,
      openSignup: false,
      drawerOpen: false,
      email: "",
      password: "",
      mobile: "",
      emailError: "",
      mobileError: "",
      passwordError: "",
      name: "",
      anchorEl: null,
      openForgotPassword: false,
    };
  }

  toggleDrawer = (open) => () => {
    this.setState({ drawerOpen: open });
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(mobile);
  };

  handleEmailChange = (e) => {
    const email = e.target.value;
    this.setState({ email });

    if (!this.validateEmail(email)) {
      this.setState({ emailError: "Please enter a valid email" });
    } else {
      this.setState({ emailError: "" });
    }
  };
  handlePasswordToggle = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.validateEmail(this.state.email)) {
      this.setState({ emailError: "Please enter a valid email" });
      return;
    }

    this.props.login(this.state.email, this.state.password);
    this.setState({ openLogin: false, email: "", password: "" });
  };
  handleForgotPasswordSubmit = (e) => {
    e.preventDefault();

    if (!this.validateEmail(this.state.email)) {
      this.setState({ emailError: "Please enter a valid email" });
      return;
    }

    this.props.forgotpassword(this.state.email);
    this.setState({ openLogin: true, openForgotPassword: false });
  };

  handleSubmitSignUp = (e) => {
    e.preventDefault();

    const { email, mobile, password, name } = this.state;
    let isValid = true;

    if (!this.validateEmail(email)) {
      this.setState({ emailError: "Please enter a valid email" });
      isValid = false;
    } else {
      this.setState({ emailError: "" });
    }

    if (!this.validateMobile(mobile)) {
      this.setState({ mobileError: "Please enter a valid mobile number" });
      isValid = false;
    } else {
      this.setState({ mobileError: "" });
    }

    if (isValid) {
      this.props.UserRegister(name, email, mobile, "U");
      this.setState({
        openSignup: false,
        openLogin: true,
        name: "",
        email: "",
        password: "",
        emailError: "",
        mobileError: "",
        mobile: "",
      });
      console.log("Signup successful!");
    }
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const access = params.get("access");
    const name = params.get("name") || ""; // Default Name
    const email = params.get("email") || ""; // Default Email
    const profile_pic = params.get("profile_pic") || ""; // Default Profile
    const mobile = params.get("mobile") || ""; // Default Mobile
    const _id = params.get("user_id") || "";

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("type", access);

      const payload = {
        name,
        email,
        token,
        access,
        _id,
        profile_pic,
        mobile,
      };

      this.props.setGoogleLoginData(payload, token);
      setTimeout(() => {
        console.log("Token stored successfully, redirecting...");
        window.location.href = "/";
      }, 500);
    } else {
      console.error("Google Login Error: Token not found in URL parameters!");
    }
  }

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout = () => {
    // Perform logout logic here
    // localStorage.removeItem("token");
    this.props.onLogout();
    this.handleMenuClose();
  };
  async handleGoogleLogin() {
    try {
      // Redirect user to backend OAuth endpoint
      window.location.href =
        "https://qrcodebackend-458148834331.asia-south1.run.app/user/google";
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  }
  render() {
    const {
      openLogin,
      openProfile,
      openSignup,
      drawerOpen,
      email,
      password,
      mobile,
      emailError,
      mobileError,
      name,
      openForgotPassword,
    } = this.state;
    const { snackbar, close_snack_bar } = this.props;
    const { login } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const drawer = (
      <Box
        sx={{
          width: 250,
          backgroundColor: "#131921",
          color: "white",
          display: "flex",
          flexDirection: "column",
        }}
        role="presentation"
        onClick={this.toggleDrawer(false)}
        onKeyDown={this.toggleDrawer(false)}>
        <Box
          sx={{
            padding: 2,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <img
            src={JnineLogo}
            alt="JnineLogo"
            style={{
              width: "50px",
              height: "50px",
              // borderRadius: "50%",
              marginBottom: "20px",
            }}
          />
          <Divider />
          {localStorage.getItem("token") !== null && (
            <Link to="/qrcode">
              <Button
                color="inherit"
                sx={{
                  color: "white",
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: "medium",
                  "&:hover": {
                    color: "purple",
                  },
                }}
                onClick={() => this.setState({ drawerOpen: false })}>
                Create Qr
              </Button>
            </Link>
          )}

          <Divider />
          <Link to="/Pricing">
            <Button
              color="inherit"
              sx={{
                color: "white",
                fontFamily: "Roboto, sans-serif",
                fontWeight: "medium",
                "&:hover": {
                  color: "purple",
                },
              }}>
              Pricing
            </Button>
          </Link>
          <Divider />
          <Link to="/faq">
            <Button
              color="inherit"
              sx={{
                color: "white",
                fontFamily: "Roboto, sans-serif",
                fontWeight: "medium",
                "&:hover": {
                  color: "purple",
                },
              }}>
              FAQ
            </Button>
          </Link>
          <Divider />
          {/* <Button
            color="inherit"
            sx={{
              color: "white",
              fontFamily: "Roboto, sans-serif",
              fontWeight: "medium",
              "&:hover": {
                color: "purple",
              },
            }}
          >
            Support
          </Button> */}
        </Box>
      </Box>
    );

    return (
      <div style={{ backgroundColor: "#f4f6f8", minHeight: "60px" }}>
        <Snackbar
          open={snackbar?.response_received}
          close_snack_bar={close_snack_bar}
          message={snackbar?.message}
        />
        <Container maxWidth="xl" style={{ padding: 0 }}>
          <AppBar position="fixed" style={{ backgroundColor: "#131921" }}>
            <Toolbar>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}>
                {/* Left Side: MenuIcon and Logo */}
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
                  <Box sx={{ display: { xs: "flex", md: "none" } }}>
                    <IconButton
                      color="inherit"
                      edge="start"
                      onClick={this.toggleDrawer(true)}>
                      <MenuIcon />
                    </IconButton>
                  </Box>

                  <RouterLink
                    to="/"
                    style={{ textDecoration: "none", color: "white" }}>
                    <img
                      src={JnineLogo}
                      alt="JnineLogo"
                      style={{
                        width: "50px",
                        height: "50px",
                        // borderRadius: "50%",
                      }}
                    />
                  </RouterLink>
                </Box>

                {/* Center: Navigation Links */}
                <Box
                  sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "center",
                    gap: 2,
                    flexWrap: "nowrap",
                  }}>
                  {localStorage.getItem("token") !== null && (
                    <RouterLink
                      to="/qrcode"
                      style={{ textDecoration: "none", color: "white" }}>
                      <Button
                        color="inherit"
                        sx={{
                          color: "white",
                          fontFamily: "Roboto, sans-serif",
                          fontWeight: "medium",
                          "&:hover": {
                            color: "purple",
                            borderRadius: "4px",
                          },
                        }}>
                        Create Qr
                      </Button>
                    </RouterLink>
                  )}
                  <RouterLink
                    to="/pricing"
                    style={{ textDecoration: "none", color: "white" }}>
                    <Button
                      color="inherit"
                      sx={{
                        color: "white",
                        fontFamily: "Roboto, sans-serif",
                        fontWeight: "medium",
                        "&:hover": {
                          color: "purple",
                          borderRadius: "4px",
                        },
                      }}>
                      Pricing
                    </Button>
                  </RouterLink>
                  <RouterLink
                    to="/faq"
                    style={{ textDecoration: "none", color: "white" }}>
                    <Button
                      color="inherit"
                      sx={{
                        color: "white",
                        fontFamily: "Roboto, sans-serif",
                        fontWeight: "medium",
                        "&:hover": {
                          color: "purple",
                          borderRadius: "4px",
                        },
                      }}>
                      FAQs
                    </Button>
                  </RouterLink>
                  {/* <RouterLink
                    to="/support"
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    <Button
                      color="inherit"
                      sx={{
                        color: "white",
                        fontFamily: "Roboto, sans-serif",
                        fontWeight: "medium",
                        "&:hover": {
                          color: "purple",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      Support
                    </Button>
                  </RouterLink> */}
                </Box>

                {/* Right Side: Login & Avatar */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {localStorage.getItem("token") === null ? (
                    <Button
                      color="inherit"
                      variant="outlined"
                      sx={{ borderColor: "white", color: "white" }}
                      onClick={() => this.setState({ openLogin: true })}>
                      Login
                    </Button>
                  ) : (
                    <>
                      <Avatar
                        alt="User Avatar"
                        src={login?.profile_pic || login?.name}
                        sx={{ width: 50, height: 50, cursor: "pointer" }}
                        onClick={this.handleMenuOpen}
                      />
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={this.handleMenuClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}>
                        <MenuItem
                          component={RouterLink}
                          to="/profile"
                          onClick={this.handleMenuClose}>
                          <AccountCircleIcon sx={{ marginRight: 1 }} />
                          Profile
                        </MenuItem>
                        <MenuItem
                          component={RouterLink}
                          to="/"
                          onClick={this.handleLogout}>
                          <LogoutIcon sx={{ marginRight: 1 }} />
                          Logout
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </Box>
              </Box>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={this.toggleDrawer(false)}>
            {drawer}
          </Drawer>

          <Dialog
            open={openLogin}
            onClose={() =>
              this.setState({
                openLogin: false,
                email: "",
                password: "",
                mobile: "",
                emailError: "",
                mobileError: "",
                passwordError: "",
                name: "",
              })
            }
            maxWidth="xs"
            fullWidth
            BackdropProps={{
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                backdropFilter: "blur(5px)",
              },
            }}>
            <Box
              sx={{
                padding: "50px",
                borderRadius: "10px",
                backgroundColor: "rgb(0,0,0)",
              }}>
              <Typography
                variant="h6"
                component="div"
                style={{
                  color: "white",
                  textAlign: "center",
                  fontFamily: "serif",
                  wordSpacing: "10px",
                  fontSize: "35px",
                }}>
                WELCOME BACK!
              </Typography>

              <form onSubmit={this.handleSubmit}>
                <TextField
                  fullWidth
                  label="Enter Your Email Address"
                  value={email}
                  onChange={this.handleEmailChange}
                  error={Boolean(emailError)}
                  helperText={emailError}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none", // 🔥 Border Remove
                      },
                      "&:hover fieldset": {
                        border: "none", // 🔥 Border Remove on Hover
                      },
                      "&.Mui-focused fieldset": {
                        border: "none", // 🔥 Border Remove on Focus
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  style={{
                    backgroundColor: "#262A34",
                    borderRadius: "20px",
                    marginTop: "10px",
                  }}
                />

                <TextField
                  fullWidth
                  label="Enter Password"
                  required
                  type={this.state.showPassword ? "text" : "password"} // Toggle based on state
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none", // 🔥 Remove Border
                      },
                      "&:hover fieldset": {
                        border: "none", // 🔥 Remove Hover Border
                      },
                      "&.Mui-focused fieldset": {
                        border: "none", // 🔥 Remove Focus Border
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  style={{
                    backgroundColor: "#262A34",
                    color: "white",
                    borderRadius: "20px",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button
                          onClick={this.handlePasswordToggle}
                          sx={{ minWidth: "auto", color: "white" }}>
                          {this.state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  type="submit"
                  variant="outlined"
                  fullWidth
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#5766FE",
                    color: "white",
                    padding: "10px",
                  }}>
                  Login
                </Button>
                <GoogleOAuthProvider clientId="458148834331-032l3iffbrnn5fqggp1caqujfhn92o6t.apps.googleusercontent.com">
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <GoogleLogin
                      onSuccess={this.handleGoogleLogin}
                      onError={() => console.error("Google Login Failed")}
                    />
                  </div>
                </GoogleOAuthProvider>
                <Typography
                  variant="body2"
                  component="div"
                  style={{
                    marginTop: "10px",
                    color: "grey",
                    textAlign: "center",
                  }}>
                  {/* <Link
                    to="/forgot-password" // Add the route for the forgot password page
                    style={{ color: "#5766FE", textDecoration: "none" }}
                  > */}
                  <b
                    onClick={(e) => {
                      this.setState({
                        openForgotPassword: true,
                        openLogin: false,
                      });
                    }}>
                    Forgot Password?
                  </b>
                  {/* </Link> */}
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  style={{
                    marginTop: "20px",
                    color: "grey",
                    textAlign: "center",
                  }}>
                  Don't have an Account?{" "}
                  <Link
                    to="/"
                    onClick={() => {
                      this.setState({ openLogin: false, openSignup: true });
                    }}>
                    <b>Sign Up</b>
                  </Link>
                </Typography>
              </form>
            </Box>
          </Dialog>
          <Dialog
            open={openForgotPassword}
            onClose={() =>
              this.setState({
                openForgotPassword: false,

                emailError: "",
              })
            }
            maxWidth="xs"
            fullWidth
            BackdropProps={{
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                backdropFilter: "blur(5px)",
              },
            }}>
            <Box
              sx={{
                padding: "50px",
                borderRadius: "10px",
                backgroundColor: "rgb(0,0,0)",
              }}>
              <Typography
                variant="h6"
                component="div"
                style={{
                  color: "white",
                  textAlign: "center",
                  fontFamily: "serif",
                  wordSpacing: "10px",
                  fontSize: "35px",
                }}>
                FORGOT PASSWORD
              </Typography>
              <Typography
                variant="body1"
                component="div"
                style={{ color: "grey", textAlign: "center" }}>
                Enter your email address to reset your password.
              </Typography>
              <form onSubmit={this.handleForgotPasswordSubmit}>
                <TextField
                  fullWidth
                  label="Enter Your Email Address"
                  value={email}
                  onChange={this.handleEmailChange}
                  error={Boolean(emailError)}
                  helperText={emailError}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none", // 🔥 Border Removed
                      },
                      "&:hover fieldset": {
                        border: "none", // 🔥 Border Removed on Hover
                      },
                      "&.Mui-focused fieldset": {
                        border: "none", // 🔥 Border Removed on Focus
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  style={{
                    backgroundColor: "#262A34",
                    borderRadius: "20px",
                    marginTop: "10px",
                  }}
                />

                <Button
                  type="submit"
                  variant="outlined"
                  fullWidth
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#5766FE",
                    color: "white",
                    padding: "10px",
                  }}>
                  Send Password
                </Button>

                <Typography
                  variant="body2"
                  component="div"
                  style={{
                    marginTop: "20px",
                    color: "grey",
                    textAlign: "center",
                  }}>
                  Remember your password?{" "}
                  <Link
                    to="/"
                    onClick={() => {
                      this.setState({
                        openForgotPassword: false,
                        openLogin: true,
                      });
                    }}>
                    <b>Login</b>
                  </Link>
                </Typography>
              </form>
            </Box>
          </Dialog>

          <Dialog
            open={openSignup}
            onClose={() =>
              this.setState({
                openSignup: false,
                email: "",
                password: "",
                mobile: "",
                emailError: "",
                mobileError: "",
                passwordError: "",
                name: "",
              })
            }
            maxWidth="xs"
            fullWidth
            BackdropProps={{
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                backdropFilter: "blur(5px)",
              },
            }}>
            <Box
              sx={{
                padding: "50px",
                borderRadius: "10px",
                backgroundColor: "rgb(0,0,0)",
              }}>
              <Typography
                variant="h6"
                component="div"
                style={{
                  color: "white",
                  textAlign: "center",
                  fontFamily: "serif",
                  wordSpacing: "10px",
                  fontSize: "35px",
                  lineHeight: "39px",
                }}>
                WELCOME !
              </Typography>
              <Typography
                variant="body1"
                component="div"
                style={{ color: "grey", textAlign: "center" }}>
                Sign up to create account.
              </Typography>
              <form onSubmit={this.handleSubmitSignUp}>
                <TextField
                  fullWidth
                  label="Enter Your Name"
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "white",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "white",
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  margin="10px"
                  style={{
                    backgroundColor: "#262A34",
                    color: "grey",
                    borderRadius: "20px",
                  }}
                />
                <TextField
                  fullWidth
                  label="Enter Your Email"
                  value={email}
                  onChange={this.handleEmailChange}
                  error={Boolean(emailError)}
                  helperText={emailError}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "white",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "white",
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  margin="10px"
                  style={{
                    backgroundColor: "#262A34",
                    color: "grey",
                    borderRadius: "20px",
                  }}
                />
                <TextField
                  fullWidth
                  label="Enter Mobile Number"
                  value={mobile}
                  onChange={(e) => this.setState({ mobile: e.target.value })}
                  error={Boolean(mobileError)}
                  helperText={mobileError}
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "white",
                      },
                      "&:hover fieldset": {
                        borderColor: "white",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "white",
                      },
                      "& input::placeholder": {
                        color: "white",
                        opacity: 1,
                      },
                    },
                  }}
                  margin="10px"
                  style={{
                    backgroundColor: "#262A34",
                    color: "grey",
                    borderRadius: "20px",
                  }}
                />

                <Button
                  type="submit"
                  variant="outlined"
                  fullWidth
                  style={{
                    marginTop: "5px",
                    backgroundColor: "#5766FE",
                    color: "white",
                    padding: "10px",
                  }}>
                  Signup
                </Button>
                <Typography
                  variant="body2"
                  component="div"
                  style={{
                    marginTop: "20px",
                    color: "grey",
                    textAlign: "center",
                  }}>
                  Already have an Account?{" "}
                  <Link
                    to="/"
                    onClick={() => {
                      this.setState({ openLogin: true, openSignup: false });
                    }}>
                    <b>Login</b>
                  </Link>
                </Typography>
              </form>
            </Box>
          </Dialog>
        </Container>
      </div>
    );
  }
}

export default Nav;
